{
	"oldParams": true,
	"wave_type": 0,
	"p_env_attack": 0,
	"p_env_sustain": 0.264,
	"p_env_punch": 0.082,
	"p_env_decay": 0.353,
	"p_base_freq": 0.091,
	"p_freq_limit": 0,
	"p_freq_ramp": 0.161,
	"p_freq_dramp": -0.093,
	"p_vib_strength": 0,
	"p_vib_speed": 0,
	"p_arp_mod": 0,
	"p_arp_speed": 0,
	"p_duty": 0.1712597437594171,
	"p_duty_ramp": 0,
	"p_repeat_speed": 0,
	"p_pha_offset": 0,
	"p_pha_ramp": 0,
	"p_lpf_freq": 0.231,
	"p_lpf_ramp": 0,
	"p_lpf_resonance": 0,
	"p_hpf_freq": 0.254,
	"p_hpf_ramp": 0,
	"sound_vol": 0.25,
	"sample_rate": 44100,
	"sample_size": 8
}
